
// Deployment trigger: 2026-04-24
export enum GameType {
  SPIN_WHEEL = 'SPIN_WHEEL',
  SCRATCH_CARD = 'SCRATCH_CARD',
  MYSTERY_BOX = 'MYSTERY_BOX',
  SLOT_MACHINE = 'SLOT_MACHINE',
  GIFT_RAIN = 'GIFT_RAIN',
  TRIVIA = 'TRIVIA',
  RAFFLE = 'RAFFLE'
}

export interface Prize {
  id: string;
  name: string;
  type: 'coupon' | 'physical' | 'digital' | 'empty';
  value: string;
  probability: number; // weight (e.g. 10, 20)
  color?: string;
  winnersCount?: number; // Number of winners for raffles
  imageUrl?: string; // Image URL for the prize
}

export interface Question {
  id: string;
  text: string;
  options: string[];
  correctIndex: number;
}

export interface GlobalConfig {
  platformName: string;
  supportEmail: string;
  defaultPrizes: Prize[];
  defaultRafflePrizes: Prize[];
  enableAnalytics: boolean;
  imageCompression?: number;
  emailSenderName?: string;
  emailSubjectTemplate?: string;
  emailContentTemplate?: string;
  smsContentTemplate?: string;
  // Game engines admins allow users to create campaigns with.
  enabledGames?: GameType[];
}

export interface Project {
  id: string;
  name: string;
  domain: string;
  createdAt: string;
  emailQuota: number;
  smsQuota: number;
  emailUsed: number;
  smsUsed: number;
  ownerId: string;
  allowedEmails?: string[];
  // How the embed behaves when this project has more than one active game:
  //  - 'all' (default): show every active game (one launcher each)
  //  - 'random': pop up one randomly chosen game per visit (A/B testing)
  embedDisplayMode?: 'random' | 'all';
}

export interface Campaign {
  id: string;
  projectId: string; // Linked project
  ownerId?: string;
  businessName?: string;
  name: string;
  type: GameType;
  prizes: Prize[];
  questions?: Question[];
  active: boolean;
  createdAt: string;
  leadsCount: number;
  viewCount: number;
  conversionRate: number;
  theme?: string;
  buttonText?: string;
  // Raffle specific
  endDate?: string;
  winnerCount?: number;
  winnersPicked?: boolean;
}

export interface Lead {
  id: string;
  campaignId: string;
  projectId: string;
  email: string;
  name?: string;
  phone?: string;
  prizeWon?: string;
  ticketNumber?: string;
  campaignCode?: string;
  createdAt: string;
}
